import React from 'react';
import SrPartnerList from 'client/components/SrPartnerList';
import SrSunSetupListingOrder from 'client/components/SrSunSetupListingOrders/SrSunSetupListingOrder/SrSunSetupListingOrder';
import SrSunSetupOrderDetails from 'client/components/SrSunSetupOrderDetails/SrSunSetupOrderDetails';

const SrSunSetupListingOrders = ({
  listing,
  sunlock,
  jobOrders,
}) => {
  const jobOrderComponents = (jobOrders || []).map((jobOrder) => (
    <SrSunSetupListingOrder
      key={jobOrder.id}
      listing={listing}
      jobOrder={jobOrder}
    />
  ));

  return (
    <>
      <SrSunSetupOrderDetails
        listing={listing}
        sunlock={sunlock}
      />
      <SrPartnerList twoColumns>
        {jobOrderComponents}
      </SrPartnerList>
    </>
  );
};

SrSunSetupListingOrders.displayName = 'SrSunSetupListingOrders';

export default SrSunSetupListingOrders;
